import React from "react";
import { Empty } from "antd";

const EmptyMemo = () => {
  return (
    <div>
      <Empty description={false} />
      <p className='text-gray-500 text-center'>No Memo</p>
    </div>
  );
};

export default EmptyMemo;
